import { DataGridWithCheckbox, type DataGridWithCheckboxProps } from '@shared/components';

export default function BaseAddProctorDetailsList(props: Readonly<DataGridWithCheckboxProps>) {
  return (
    <DataGridWithCheckbox
      {...props}
      columnHeaderHeight={48}
      rowHeight={48}
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        minHeight: '100%',
        '.MuiDataGrid-cell': {
          p: theme.spacing(3),
          alignItems: 'flex-start',
        },
        '.MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-cellCheckbox': {
          padding: theme.spacing(0),
        },
        '.MuiDataGrid-row--lastVisible': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '--DataGrid-overlayHeight': '480px',
      })}
    />
  );
}
